const isProdEnvironment = () => {
	const hostnameParts = window.location.hostname.split('.');
	return hostnameParts[hostnameParts.length - 1] === 'com';
};

export const CHECKOUT_URL = `https://website-gateway.meisterplan.${isProdEnvironment() ? 'com' : 'io'}/checkout`;
export const REGION_API_URL = 'https://website-gateway.meisterplan.com/api/public/v1/region';
export const URL_CONFIG_GET_PARAM = 'pricing-config';
export const MP_WEBAPP_RESOURCE_PARAM = 'resourceCount';
